import { CERBERUS_STATS_FIELDS } from '@hcs/types';

export const LISTING_STATS_RENTAL_FIELDS = [
  CERBERUS_STATS_FIELDS.daysOnMarketMedianRental,
  CERBERUS_STATS_FIELDS.daysOnMarketMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianRental,
  CERBERUS_STATS_FIELDS.daysOnMarketNotContractMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysToCloseMedianRental,
  CERBERUS_STATS_FIELDS.daysToCloseMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysToContractMedianRental,
  CERBERUS_STATS_FIELDS.daysToContractMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianRental,
  CERBERUS_STATS_FIELDS.daysToFirstPriceDropMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsClosedCountRental,
  CERBERUS_STATS_FIELDS.listingsClosedCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsNewCountRental,
  CERBERUS_STATS_FIELDS.listingsNewCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsOnMarketCountRental,
  CERBERUS_STATS_FIELDS.listingsOnMarketCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsPriceChangeCountRental,
  CERBERUS_STATS_FIELDS.listingsPriceChangeCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropCountRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropPercentRental,
  CERBERUS_STATS_FIELDS.listingsPriceDropPercentMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsRemovedCountRental,
  CERBERUS_STATS_FIELDS.listingsRemovedCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsRemovedPercentRental,
  CERBERUS_STATS_FIELDS.listingsRemovedPercentMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractCountRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractCountMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractPercentRental,
  CERBERUS_STATS_FIELDS.listingsUnderContractPercentMovingAvgRental,
  CERBERUS_STATS_FIELDS.listingStatsEventDateRental,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedianRental,
  CERBERUS_STATS_FIELDS.monthsOfSupplyMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.priceClosedMedianRental,
  CERBERUS_STATS_FIELDS.priceClosedMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.priceNewListMedianRental,
  CERBERUS_STATS_FIELDS.priceNewListMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.priceOnMarketMedianRental,
  CERBERUS_STATS_FIELDS.priceOnMarketMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianRental,
  CERBERUS_STATS_FIELDS.pricePerSqftClosedMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianRental,
  CERBERUS_STATS_FIELDS.pricePerSqftNewListMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianRental,
  CERBERUS_STATS_FIELDS.pricePerSqftOnMarketMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.saleToListPriceMedianRental,
  CERBERUS_STATS_FIELDS.saleToListPriceMedianMovingAvgRental,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianRental,
  CERBERUS_STATS_FIELDS.saleToListPriceOriginalMedianMovingAvgRental,
];
